import { useState, useRef, useEffect } from 'react';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import FormHelperText from '@material-ui/core/FormHelperText';
import CloseIcon from '@material-ui/icons/Close';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import dayjs from 'dayjs';
import { OPT_DETAIL } from '@/constants.js';
import webStorage from '@/utils/storageManager';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import ModalML from '@/components/ModalML/NewModalML';
import { fmtThousand } from '@/utils/comUtil';
import { TextFieldCom } from '@/components/FormType';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import CouponML from '../CouponML';
import HeadlineML from '../HeadlineML';
import Styled from './styles';

// 1. 先定义统一的数组项默认值（便于复用）
const createObj = () => ({
  id: `prize_${Date.now()}`, // 用时间戳生成唯一id，避免重复
  title: '',
  quantity: '',
  remainingQuantity: '',
  type: 'COUPON', // 初始默认优惠券类型
  coupons: null,
  point: '',
  prizeId: '',
});
export default ({
  handleExitClick,
  queryType,
  handleSubmitSuccessPrize,
  handleSubmitFailPrize,
  defaultValuesData,
  isNext,
  setIsNext,
  step,
  status,
  id,
}) => {
  const {
    control,
    setValue,
    errors,
    getValues,
    handleSubmit,
    trigger,
    reset,
    watch,
    formState: { errors: formErrors },
  } = useForm({
    defaultValues: {
      prizeModel: id ? [] : [createObj()],
    },
  });
  const { COUPON_TYPE = [] } = webStorage.get('DICTOBJ') || {};
  const [couponDialogStatus, setCouponDialogStatus] = useState(false);
  const [saveItem, setSaveItem] = useState();
  const [couponList, setCouponList] = useState([]);
  const [switchData, setSwitchData] = useState([]);
  const [invalidData, setInvalidData] = useState([]);
  const [isClick, setIsClick] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const submitRef = useRef();
  const typeList = COUPON_TYPE.map((item) => ({
    value: item.dictCode,
    name: item.nameZh,
  }));
  const { fields, append, remove } = useFieldArray({
    control: control,
    name: 'prizeModel',
  });
  useEffect(() => {
    if (defaultValuesData) {
      const { prizeModel } = defaultValuesData;
      const indexs = prizeModel.map((i, index) => index);
      setSwitchData(indexs);
      reset(defaultValuesData);
    }
  }, [defaultValuesData, reset]);

  // 重置指定索引项的某个字段值
  const resetFieldValue = (index, fieldName, value) => {
    setValue(`prizeModel.${index}.${fieldName}`, value);
  };

  // 获取指定item的某个值
  const getFieldValue = (index, fieldName) => {
    // 字段路径格式：数组名.索引.字段名

    return getValues(`prizeModel.${index}.${fieldName}`);
  };
  //关联优惠券
  const handleAddCouponClick = (index, fieldName) => {
    setSaveItem({ index, fieldName });
    setCouponDialogStatus(true);
  };
  //替换优惠券
  const handleChangeCouponClick = (index, fieldName) => {
    setSaveItem({ index, fieldName });
    setCouponDialogStatus(true);
    const list = getFieldValue(index, fieldName);
    setCouponList([list]);
  };
  //删除优惠券
  const handleDeleteCouponClick = (index, fieldName) => {
    setCouponList([]);
    resetFieldValue(index, fieldName, null);
  };
  const handleCloseCoupon = () => {
    setCouponDialogStatus(false);
  };

  const handleAddCoupon = (list) => {
    setCouponList(list);
    resetFieldValue(saveItem.index, saveItem.fieldName, list[0]);
  };
  //   const couponList = useMemo(() => {
  //     if (saveItem?.fieldName) {
  //       const data = getFieldValue(saveItem.index, saveItem.fieldName);
  //       return data;
  //     }
  //     return [];
  //   }, [saveItem]);

  const handleDeleteItem = (index) => {
    setDeleteIndex(index);
    setOpenDialog(true);
  };
  const handleAddPrize = () => {
    append(createObj());
    setCouponList([]);
    const length = fields.length;
    setTimeout(() => {
      resetFieldValue(length, 'type', 'COUPON');
    }, 500);
  };

  const handleSwitch = (index) => {
    const findIndex = switchData.includes(index);
    if (findIndex) {
      setSwitchData([...switchData].filter((i) => i !== index));
    } else {
      setSwitchData([...switchData, index]);
      handleTriggerItem(index);
    }
  };

  // 在需要同时触发多个字段校验的地方
  const validateFields = async (index) => {
    try {
      // 将所有需要触发的校验放入数组
      const validationPromises = [
        trigger(`prizeModel.${index}.title`),
        trigger(`prizeModel.${index}.quantity`),
      ];
      const type = getFieldValue(index, 'type');
      if (type === 'COUPON') {
        validationPromises.push(trigger(`prizeModel.${index}.coupons`));
      } else {
        validationPromises.push(trigger(`prizeModel.${index}.point`));
      }
      if (id && queryType !== OPT_DETAIL) {
        validationPromises.push(
          trigger(`prizeModel.${index}.remainingQuantity`),
        );
      }

      // 使用 Promise.all 获取所有校验结果
      const results = await Promise.all(validationPromises);

      // results 是一个布尔值数组，每个元素对应上述字段的校验结果
      // 例如：[true, true, false] 表示前两个字段校验通过，最后一个失败

      // 可以判断所有字段是否都通过校验
      const allPassed = results.every((result) => result);
      return {
        results,
        allPassed,
      };
    } catch (error) {
      console.error('校验过程出错:', error);
      return {
        results: [],
        allPassed: false,
      };
    }
  };

  // 校验所有奖品项，返回失败的索引数组
  const validateAllPrizeItems = async () => {
    const failedIndexes = [];

    for (let i = 0; i < fields.length; i++) {
      const validateData = await validateFields(i);
      if (!validateData.allPassed) {
        failedIndexes.push(i);
      }
    }

    return failedIndexes;
  };

  // 展开所有校验失败的item并滚动到第一个失败的item
  const expandFailedItemsAndScroll = (failedIndexes) => {
    if (failedIndexes.length === 0) {
      return;
    }

    // 展开所有失败的item（从switchData中移除失败的索引，使其保持展开状态）
    const newSwitchData = switchData.filter(
      (index) => !failedIndexes.includes(index),
    );
    setSwitchData(newSwitchData);

    // 更新invalidData状态
    setInvalidData(failedIndexes);

    // 滚动到第一个失败的item
    const firstFailedIndex = failedIndexes[0];
    setTimeout(() => {
      const element = document.querySelector(
        `[data-prize-index="${firstFailedIndex}"]`,
      );
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }, 100);
  };

  const handleTriggerItem = async (index, buttonStatus) => {
    const validateData = await validateFields(index);
    if (validateData.allPassed) {
      if (buttonStatus) {
        window.message.toast({
          type: 'success',
          message: '保存成功',
        });
        setSwitchData([...switchData, index]);
      }
      setInvalidData([...invalidData].filter((i) => i !== index));
    } else {
      setInvalidData([...invalidData, index]);
    }
  };

  useEffect(() => {
    // 当 isNext 变为 true 时执行点击
    if (isNext && submitRef.current && step === 2 && isClick) {
      const indexs = watch('prizeModel')?.map((i, index) => index) || [];
      setSwitchData(indexs);
      submitRef.current.click();
      setIsClick(false);
    }
  }, [isNext, step, isClick, watch]);
  const handleClickNext = async () => {
    // 先校验所有奖品项
    const failedIndexes = await validateAllPrizeItems();

    if (failedIndexes.length > 0) {
      // 如果有校验失败的项，展开失败的item并滚动到第一个
      expandFailedItemsAndScroll(failedIndexes);
      return; // 不继续提交
    }

    // 如果所有项都校验通过，继续正常流程
    setIsNext(true);
    setIsClick(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleDeletePrizeItem = () => {
    remove(deleteIndex);
    setDeleteIndex(null);
    setOpenDialog(false);
  };

  // 新增：奖品标题唯一性校验函数
  const isTitleUnique = (value, index) => {
    if (!value) {
      return true;
    }
    const allTitles = (watch('prizeModel') || []).map((item) =>
      (item.title || '').trim(),
    );
    // 只要有别的index的title和当前value相同（忽略前后空格），就不唯一
    return (
      allTitles.filter(
        (t, idx) => idx !== index && t && value && t.trim() === value.trim(),
      ).length === 0
    );
  };

  return (
    <Styled>
      <form
        onSubmit={handleSubmit(handleSubmitSuccessPrize, handleSubmitFailPrize)}
      >
        <div className="prize-wrap">
          <div className="left-content">
            <HeadlineML title="奖品设置" style={{ marginBottom: '16px' }} />
            {fields.map((item, index) => {
              const title = getFieldValue(index, 'title');

              return (
                <div
                  className={`prize-content-wrap ${
                    switchData.includes(index) && invalidData.includes(index)
                      ? 'prize-content-wrap-undo'
                      : ''
                  }`}
                  key={item.id}
                  data-prize-index={index}
                >
                  <div className="prize-content-top">
                    <div className="left">
                      <div
                        className={`left-icon  ${
                          switchData.includes(index) ? 'left-icon-close' : ''
                        } ${
                          switchData.includes(index) &&
                          invalidData.includes(index)
                            ? 'left-undo'
                            : ''
                        }`}
                        onClick={() => handleSwitch(index)}
                      >
                        <SvgIconML
                          name="prize-triangle"
                          size={12}
                          stroke={
                            switchData.includes(index) &&
                            invalidData.includes(index)
                              ? '#C01515'
                              : '#1565C0'
                          }
                        />
                      </div>
                      <div className="left-name">{title}</div>
                    </div>
                    {switchData.includes(index) &&
                      !invalidData.includes(index) && (
                        <div className="right">
                          <CheckIcon sx={{ width: '20px', height: '20px' }} />
                          设置完成
                        </div>
                      )}
                    {switchData.includes(index) && invalidData.includes(index) && (
                      <div className="right undo">
                        <ErrorOutlineIcon
                          sx={{ width: '20px', height: '20px' }}
                        />
                        未完成
                      </div>
                    )}
                  </div>
                  <div
                    className={`prize-content-bottom ${
                      switchData.includes(index)
                        ? 'prize-content-bottom-close'
                        : ''
                    }`}
                  >
                    <Controller
                      control={control}
                      name={`prizeModel.${index}.prizeId`}
                      as={<input hidden />}
                    />
                    <div className="prize-content-bottom-line">
                      <Controller
                        control={control}
                        name={`prizeModel.${index}.title`}
                        rules={{
                          required: true,
                          maxLength: 15,
                          pattern: {
                            value: /^(?!\s+$)[\s\S]*$/,
                            message: '不能全为空格',
                          },
                          validate: (value) => {
                            if (!isTitleUnique(value, index)) {
                              return '奖品标题不能重复';
                            }
                            return true;
                          },
                        }}
                        render={({ value, onChange }, { invalid }) => {
                          const fieldError =
                            formErrors?.prizeModel?.[index]?.title;
                          return (
                            <TextField
                              label={
                                <>
                                  <span className="required-star">*</span>
                                  奖品标题
                                </>
                              }
                              disabled={
                                status === '1' || queryType === OPT_DETAIL
                              }
                              variant="standard"
                              sx={{ width: '310px' }}
                              value={value || ''} // 处理初始值为undefined的情况
                              onChange={(e) => onChange(e.target.value)} // 显式绑定 onChange
                              error={invalid}
                              helperText={
                                fieldError?.message
                                  ? fieldError.message
                                  : invalid && '请输入奖品标题不超过15个字'
                              }
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      className="clear-btn"
                                      onClick={() => onChange('')}
                                      edge="end"
                                      disabled={
                                        status === '1' ||
                                        queryType === OPT_DETAIL
                                      }
                                    >
                                      {value ? (
                                        <ClearIcon className="clear-icon" />
                                      ) : (
                                        ''
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          );
                        }}
                      />
                      <Controller
                        control={control}
                        name={`prizeModel.${index}.quantity`}
                        rules={{
                          required: true,
                          validate: (newValue) => {
                            let isPass = newValue >= 1;
                            if (!id) {
                              isPass = newValue >= 1 && newValue <= 1000000;
                            }
                            return isPass;
                          },
                          pattern: /^(0|[1-9]\d*)$/,
                        }}
                        render={({ value, onChange }, { invalid }) => {
                          return (
                            <TextField
                              label={
                                <>
                                  <span className="required-star">*</span>
                                  奖品数量
                                </>
                              }
                              disabled={queryType === OPT_DETAIL}
                              variant="standard"
                              sx={{ width: '200px' }}
                              error={invalid}
                              helperText={
                                invalid && '请输入不大于1000000的正整数'
                              }
                              value={value || ''} // 处理初始值为undefined的情况
                              onChange={(e) => {
                                onChange(e.target.value);
                                if (id && queryType !== OPT_DETAIL) {
                                  //当前剩余库存
                                  const oldRemainingQuantity = Number(
                                    defaultValuesData.prizeModel[index]
                                      .remainingQuantity,
                                  );
                                  //当前库存
                                  const oldQuantity = Number(
                                    defaultValuesData.prizeModel[index]
                                      .quantity,
                                  );
                                  const newRemainingQuantity =
                                    Number(e.target.value || '') -
                                      Number(oldQuantity) +
                                      Number(oldRemainingQuantity) || '0';
                                  resetFieldValue(
                                    index,
                                    'remainingQuantity',
                                    newRemainingQuantity,
                                  );
                                }
                              }} // 显式绑定 onChange
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      className="clear-btn"
                                      onClick={() => {
                                        onChange('');
                                      }}
                                      edge="end"
                                      disabled={queryType === OPT_DETAIL}
                                    >
                                      {value ? (
                                        <ClearIcon className="clear-icon" />
                                      ) : (
                                        ''
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          );
                        }}
                      />
                      <Controller
                        control={control}
                        name={`prizeModel.${index}.remainingQuantity`}
                        rules={{
                          validate: (newValue) => {
                            if (id) {
                              if (queryType !== OPT_DETAIL) {
                                return newValue >= 0;
                              }
                              return true;
                            }
                            return true;
                          },
                        }}
                        render={({ value }, { invalid }) => {
                          return (
                            <TextField
                              label="当前剩余数量"
                              variant="standard"
                              sx={{ width: '200px' }}
                              disabled
                              value={value || ''} // 处理初始值为undefined的情况
                              error={invalid}
                              helperText={invalid && '剩余数量不能小于0'}
                            />
                          );
                        }}
                      />
                    </div>
                    <div className="prize-content-bottom-line">
                      <Controller
                        control={control}
                        name={`prizeModel.${index}.type`} // 与 defaultValues 字段名一致
                        rules={{ required: true }} // 可选：添加必填校验
                        render={({ value, onChange }) => (
                          <FormControl
                            component="fieldset"
                            className="checkbox-radio-disabled-color"
                          >
                            <FormLabel
                              component="legend"
                              sx={{ fontSize: '12px', color: '#555' }}
                            >
                              <span className="required-star">*</span>奖品类型
                            </FormLabel>
                            <RadioGroup
                              aria-label="奖品类型"
                              row
                              value={value || 'COUPON'}
                              onChange={(event) => {
                                onChange(event.target.value);
                              }}
                              name={`prizeModel.${index}.type`} // 必须与 Controller 的 name 一致，不能硬编码
                            >
                              <FormControlLabel
                                value="COUPON"
                                control={<Radio />}
                                label="优惠券"
                                disabled={
                                  status === '1' || queryType === OPT_DETAIL
                                } // 保持禁用逻辑
                              />
                              <FormControlLabel
                                value="POINT"
                                control={<Radio />}
                                label="积分"
                                disabled={
                                  status === '1' || queryType === OPT_DETAIL
                                } // 保持禁用逻辑
                              />
                            </RadioGroup>
                          </FormControl>
                        )}
                      />
                    </div>
                    <div
                      style={{
                        display:
                          watch('prizeModel')?.[index]?.type === 'COUPON'
                            ? 'block'
                            : 'none',
                      }}
                    >
                      <FormControl variant="standard" sx={{ height: '163px' }}>
                        <Controller
                          name={`prizeModel.${index}.coupons`}
                          control={control}
                          as={
                            <Box className="coupon-card-wrap">
                              <Box
                                className={`card-item ${
                                  !watch('prizeModel')?.[index]?.coupons
                                    ? 'card-item-no-data'
                                    : ''
                                }`}
                              >
                                <Box className="card-item-wrap">
                                  <Box className="card-item-name">
                                    {watch('prizeModel')?.[index]?.coupons
                                      ?.title || '-'}
                                  </Box>
                                  <Box>
                                    <Box className="card-item-info-1">
                                      优惠券 有效期
                                    </Box>
                                    <Box className="card-item-info-2">
                                      <Box className="card-item-info-3">
                                        {watch('prizeModel')?.[index]?.coupons
                                          ?.beginTime
                                          ? dayjs(
                                              watch('prizeModel')[index].coupons
                                                .beginTime,
                                            ).format('YYYY-MM-DD')
                                          : '-'}
                                      </Box>
                                      <Box className="card-item-info-4">至</Box>
                                      <Box className="card-item-info-3">
                                        {watch('prizeModel')?.[index]?.coupons
                                          ?.endTime
                                          ? dayjs(
                                              watch('prizeModel')[index].coupons
                                                .endTime,
                                            ).format('YYYY-MM-DD')
                                          : '-'}
                                      </Box>
                                    </Box>
                                  </Box>
                                </Box>
                                <Box className="card-item-info-5">
                                  <Box>
                                    <Box className="card-item-info-6">
                                      优惠券 ID
                                    </Box>
                                    <Box className="card-item-info-7">
                                      <Box className="card-item-info-8">
                                        {
                                          watch('prizeModel')?.[index]?.coupons
                                            ?.id
                                        }
                                      </Box>
                                    </Box>
                                  </Box>
                                  <Box>
                                    <Box className="card-item-info-6">
                                      优惠券 类型
                                    </Box>
                                    <Box className="card-item-info-7">
                                      <Box className="card-item-info-8">
                                        {
                                          typeList.find(
                                            (it) =>
                                              it.value ===
                                              watch('prizeModel')?.[index]
                                                ?.coupons?.typeName,
                                          )?.name
                                        }
                                      </Box>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                              <div
                                style={{
                                  display:
                                    status === '1' || queryType === OPT_DETAIL
                                      ? 'none'
                                      : 'block',
                                }}
                              >
                                {!watch('prizeModel')?.[index]?.coupons ? (
                                  <Button
                                    variant="contained"
                                    onClick={() =>
                                      handleAddCouponClick(index, 'coupons')
                                    }
                                    sx={{
                                      width: '68px',
                                      borderRadius: '24px',
                                      height: '40px',
                                      lineHeight: '36px',
                                    }}
                                  >
                                    关联
                                  </Button>
                                ) : (
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      gap: '0 16px',
                                    }}
                                  >
                                    <Button
                                      variant="outlined"
                                      onClick={() => {
                                        handleChangeCouponClick(
                                          index,
                                          'coupons',
                                        );
                                      }}
                                      sx={{
                                        width: '68px',
                                        borderRadius: '24px',
                                        height: '36px',
                                        lineHeight: '36px',
                                        color: '#1565C0',
                                      }}
                                    >
                                      替换
                                    </Button>
                                    <Button
                                      variant="outlined"
                                      onClick={() => {
                                        handleDeleteCouponClick(
                                          index,
                                          'coupons',
                                        );
                                      }}
                                      sx={{
                                        width: '68px',
                                        borderRadius: '24px',
                                        color: '#F50057',
                                        borderColor: '#F50057',
                                        height: '36px',
                                        lineHeight: '36px',
                                      }}
                                    >
                                      删除
                                    </Button>
                                  </Box>
                                )}
                              </div>
                            </Box>
                          }
                          rules={{
                            required:
                              watch('prizeModel')?.[index]?.type === 'COUPON',
                          }}
                        />
                        {errors?.prizeModel?.[index]?.coupons && (
                          <FormHelperText
                            error={Boolean(errors.prizeModel?.[index]?.coupons)}
                            sx={{ position: 'relative' }}
                          >
                            {Boolean(
                              errors.prizeModel?.[index]?.coupons?.type ===
                                'required',
                            ) && '请选择优惠券'}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </div>
                    <div
                      style={{
                        display:
                          watch('prizeModel')?.[index]?.type === 'POINT'
                            ? 'block'
                            : 'none',
                      }}
                    >
                      <Controller
                        label={
                          <>
                            <span className="required-star">*</span>积分数量
                          </>
                        }
                        control={control}
                        name={`prizeModel.${index}.point`}
                        render={({ value, onChange }, { invalid }) => {
                          return (
                            <TextField
                              disabled={
                                status === '1' || queryType === OPT_DETAIL
                              }
                              variant="standard"
                              sx={{ width: '200px' }}
                              error={invalid}
                              helperText={
                                invalid && '请输入大于等于1的整数积分数量'
                              }
                              value={value || ''}
                              onChange={(event) => {
                                return onChange(event.target.value);
                              }}
                              onBlur={(event) => {
                                const reg = /^(0|[1-9]\d*)(\.\d+)?$/;
                                const isNumber = reg.test(event.target.value);
                                if (isNumber) {
                                  const v = event.target.value
                                    ? fmtThousand(
                                        Number(event.target.value),
                                        2,
                                        true,
                                      )
                                    : '';
                                  return onChange(v);
                                }
                                return onChange(event.target.value);
                              }}
                              onFocus={(e) => {
                                let v = e.target.value.replace(/,/g, '');
                                return onChange(v);
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      className="clear-btn"
                                      onClick={() => {
                                        onChange('');
                                      }}
                                      edge="end"
                                      disabled={
                                        status === '1' ||
                                        queryType === OPT_DETAIL
                                      }
                                    >
                                      {value ? (
                                        <ClearIcon className="clear-icon" />
                                      ) : (
                                        ''
                                      )}
                                    </IconButton>
                                    <span
                                      style={{
                                        fontSize: '14px',
                                        color: '#999999',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      分
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          );
                        }}
                        rules={{
                          required:
                            watch('prizeModel')?.[index]?.type === 'POINT',
                          pattern:
                            watch('prizeModel')?.[index]?.type === 'POINT'
                              ? /^(0|([1-9]\d*)(?:,\d{3})*|([1-9]\d{0,2}(?:,\d{3})+))$/
                              : undefined,
                          validate:
                            watch('prizeModel')?.[index]?.type === 'POINT'
                              ? (newValue) =>
                                  newValue > 0 &&
                                  newValue <=
                                    (watch('prizeModel')?.[index]?.point ||
                                      10000)
                              : undefined,
                        }}
                      />
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        gap: '0 8px',
                        justifyContent: 'flex-end',
                      }}
                    >
                      {fields.length > 1 && (
                        <Button
                          style={{
                            width: '68px',
                            borderRadius: '24px',
                            height: '40px',
                            lineHeight: '36px',
                            display:
                              status === '1' || queryType === OPT_DETAIL
                                ? 'none'
                                : 'inherit',
                          }}
                          color="secondary"
                          variant="contained"
                          onClick={() => handleDeleteItem(index)}
                        >
                          删除
                        </Button>
                      )}
                      {queryType !== OPT_DETAIL && (
                        <Button
                          style={{
                            width: '68px',
                            borderRadius: '24px',
                            height: '40px',
                            lineHeight: '36px',
                          }}
                          variant="contained"
                          onClick={() => handleTriggerItem(index, true)}
                        >
                          完成
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            <Button
              variant="contained"
              className="setting-button"
              style={{
                width: '124px',
                borderRadius: '24px',
                height: '44px',
                display:
                  status === '1' ||
                  queryType === OPT_DETAIL ||
                  watch('prizeModel')?.length > 8
                    ? 'none'
                    : 'inherit',
              }}
              startIcon={<AddIcon sx={{ width: '24px', height: '24px' }} />}
              onClick={handleAddPrize}
            >
              追加奖品
            </Button>
          </div>
          <div className="middle-content"></div>
          <div className="right-content">
            <HeadlineML
              title="无奖品设置"
              subTitle="此处配置未中奖的相关内容"
            />
            <TextFieldCom
              control={control}
              label="无奖品标题"
              name="noPrizeTitle"
              getValues={getValues}
              setValue={setValue}
              errors={errors}
              initErrorText="请填写中文、英文和数字，不可超过15个字"
              disabled={status === '1' || queryType === OPT_DETAIL}
              rules={{
                required: true,
                maxLength: 15,
                pattern: /^[\u4e00-\u9fa5a-zA-Z0-9._]*$/,
              }}
            />
            <TextFieldCom
              control={control}
              label="无奖品ID"
              name="noPrizeId"
              getValues={getValues}
              setValue={setValue}
              errors={errors}
              hidden
            />
            <TextFieldCom
              style={{ height: '100%' }}
              label="无奖品通知"
              showError={true}
              control={control}
              name="notice"
              setValue={setValue}
              getValues={getValues}
              disabled={status === '1' || queryType === OPT_DETAIL}
              rules={{
                maxLength: 200,
              }}
              errors={errors}
              multiline={true}
              maxRows="17"
              minRows="17"
              variant="outlined"
              textClassName="textField-area-wrap"
              placeholder="请输入"
            />
          </div>
        </div>
        <div className="from-button-wrap">
          <Button
            color="secondary"
            variant="contained"
            className="goFront"
            type="submit"
            sx={{ width: '96px' }}
          >
            上一页
          </Button>
          <Button
            variant="contained"
            className="goFront"
            sx={{ width: '96px' }}
            onClick={handleClickNext}
          >
            下一页
          </Button>
          <button ref={submitRef} type="submit" hidden></button>
          <div
            style={{
              height: '40px',
              width: '1px',
              backgroundColor: '#E5E5E5',
            }}
          ></div>
          <Button
            color="secondary"
            variant="contained"
            className="exit"
            onClick={handleExitClick}
            startIcon={<CloseIcon sx={{ width: '20px', height: '20px' }} />}
            sx={{ width: '96px' }}
          >
            退出
          </Button>
        </div>
      </form>
      <ModalML
        open={couponDialogStatus}
        setOpen={setCouponDialogStatus}
        onCancel={handleCloseCoupon}
        title="选择优惠券"
        onConfirm={handleAddCoupon}
        onClose={handleCloseCoupon}
      >
        <CouponML
          open={couponDialogStatus}
          control={control}
          setOpen={setCouponDialogStatus}
          onConfirm={handleAddCoupon}
          chooseList={couponList}
          setChooseList={setCouponList}
        ></CouponML>
      </ModalML>
      <DialogDataML
        open={openDialog}
        title={'删除'}
        content={'确定要删除该奖品吗？'}
        handleClose={handleCloseDialog}
        handleConfirm={handleDeletePrizeItem}
      ></DialogDataML>
    </Styled>
  );
};
